import { createFileRoute, notFound } from "@tanstack/react-router";
import { getPage } from "@/content/pages";
import { MarkdownPage } from "@/components/MarkdownPage";
import { breadcrumbScript, SITE_URL } from "@/lib/seo";

const PAGE_KEY = "/seo/bespoke-seo-website-audits";

export const Route = createFileRoute("/seo/bespoke-seo-website-audits")({
  loader: () => {
    const page = getPage(PAGE_KEY);
    if (!page) throw notFound();
    return page;
  },
  head: ({ loaderData }) => ({
    meta: loaderData
      ? [
          { title: loaderData.title },
          { name: "description", content: loaderData.description },
          { property: "og:title", content: loaderData.title },
          { property: "og:description", content: loaderData.description },
          {
            property: "og:url",
            content: "https://www.phil-carr.co.uk/seo/bespoke-seo-website-audits",
          },
        ]
      : [],
    links: [
      { rel: "canonical", href: "https://www.phil-carr.co.uk/seo/bespoke-seo-website-audits" },
    ],
    scripts: loaderData
      ? [
          breadcrumbScript([
            { name: "Home", url: `${SITE_URL}/` },
            { name: "SEO", url: `${SITE_URL}/seo` },
            { name: loaderData.title, url: `${SITE_URL}${PAGE_KEY}` },
          ]),
        ]
      : [],
  }),
  notFoundComponent: () => (
    <div className="container mx-auto max-w-3xl px-6 py-24 text-center">
      <h1 className="font-display text-4xl">Page not found</h1>
    </div>
  ),
  errorComponent: ({ error }) => (
    <div className="container mx-auto max-w-3xl px-6 py-24 text-center">
      <h1 className="font-display text-3xl">Something went wrong</h1>
      <p className="mt-3 text-muted-foreground">{error.message}</p>
    </div>
  ),
  component: Page,
});

function Page() {
  const page = Route.useLoaderData();
  return (
    <MarkdownPage
      body={page.body}
      pageContext={page.title}
      relatedSlugs={[
        "common-seo-mistakes-that-hold-small-businesses-back",
        "why-seo-starts-with-your-website-and-always-will",
        "creating-an-seo-plan-that-supports-long-term-success",
      ]}
    />
  );
}
